import React from 'react';

function DockingModule({ onSubmit }) {
  const handleSubmit = () => {
    const mode = document.getElementById('dockMode').value;
    const rec = document.getElementById('recFile').files[0];
    const lig = document.getElementById('ligFile').files[0];
    if (!rec || !lig) return alert("请上传受体和配体文件");

    const form = new FormData();
    form.append('dockingMode', mode);
    form.append('receptorFile', rec);
    form.append('ligandFile', lig);
    onSubmit('分子对接', form, 'dock');
  };

  return (
    <div className="flex flex-col h-full">
      <select id="dockMode" className="form-select">
        <option value="basic">basic</option>
        <option value="flexible">flexible</option>
        <option value="smina">smina</option>
        <option value="smina_metal">smina_metal</option>
        <option value="gnina">gnina</option>
      </select>
      <input type="file" id="recFile" className="form-input mt-2" />
      <input type="file" id="ligFile" className="form-input mt-2" />
      <div className="flex justify-center mt-auto pt-4">
        <button onClick={handleSubmit} className="btn-primary">提交任务</button>
      </div>
    </div>
  );
}

export default DockingModule;

